import { combineReducers } from "@reduxjs/toolkit";

import { sentAnnouncementsListingReducer } from "./SentAnnouncementsListingSlice";

export const announcementsReducer = combineReducers({
  sentAnnouncements: sentAnnouncementsListingReducer,
});
